export default "__VITE_ASSET__CEaJeY4P__"